module.exports = __webpack_public_path__ + "static/media/l12_voice_four_v2.b1e7a069.mp3";